import { useQuery } from "react-query";
import { getEmployeeHierarchyById } from "../../../../../actions/Employees";

export const useGetEmployeeHierarchyById = (employeeId) => {
  return useQuery(
    ["GetEmployeeHierarchyById", employeeId],
    () => getEmployeeHierarchyById(employeeId),
    { refetchOnWindowFocus: false }
  );
};
